export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_09.21baf44e.jpg";